<!--
 * @Date: 2020-08-21 17:39:25
 * @Author: MX
 * @LastEditTime: 2023-09-19 13:43:49
 * @Description: 注册
-->
<template>
  <div class="register">
    <div class="register-box">
      <div class="iconBox">
        <i class="iconfont iconjitulogo_fanbai" v-if="$i18n.locale === 'zh-cn'"></i>
        <i class="iconfont icona-JTexpress" v-else></i>
      </div>
      <div class="title" :class="$i18n.locale">
        {{$t("极兔开放平台")}}
      </div>
      <div class="form">
        <el-form ref="registerForm" :model="registerForm" :rules="rules" autocomplete="off" class="register-Form">
          <el-form-item prop="account">
            <el-input :placeholder="$lang('请输入账号')" v-model="registerForm.account" @blur="checkAccount">
              <i slot="prefix" class="iconfont icondengluzhuce_yonghuming" :class="registerForm.account && 'red_color'"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input :placeholder="$lang('请输入密码')" :type="isShowPassword ? 'text' : 'password'" maxlength="20" v-model="registerForm.password">
              <i slot="prefix" class="iconfont icondengluzhuce_mima" :class="registerForm.password && 'red_color'"></i>
              <i slot="suffix" class="iconfont pointer" :class="[
                  isShowPassword
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang',
                ]" @click="toggleIcon"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input :placeholder="$lang('请输入邮箱')" v-model="registerForm.email">
              <i slot="prefix" class="iconfont icondengluzhuce_youxiang" :class="registerForm.email && 'red_color'"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="emailCode" class="phoneCodeItem">
            <el-input :placeholder="$lang('请输入邮箱验证码')" maxlength="6" v-model="registerForm.emailCode">
              <i slot="prefix" class="iconfont icondengluzhuce_shurushoujiyanzhengma" :class="registerForm.emailCode && 'red_color'"></i>
            </el-input>
            <button class="sendcodeBtn commonBtn" @click.prevent="sendEmailCode" :disabled="isSendEmailCode || isSendEmailLoading || !isEmailValid" v-loading="isSendEmailLoading">
              <span v-if="!isSendEmailCode">{{$lang("发送")}}</span>
              <span v-else>{{ emailTime }}{{$lang("秒")}}</span>
            </button>
          </el-form-item>
          <el-form-item prop="phone" class="phone">
            <el-input :placeholder="$lang('请输入手机号')" @blur="checkPhone" v-model="registerForm.phone">
              <!-- <i slot="prefix" class="iconfont icondengluzhuce_shouji" :class="registerForm.phone && 'red_color'"></i> -->
              <template #prepend>
                <el-select v-model="registerForm.countryCode" :placeholder="$lang('区号')">
                  <el-option
                    v-for="item in countryCodeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item class="codeFormItem" prop="captcha">
            <el-input :placeholder="$lang('请输入验证码')" maxlength="4" v-model="registerForm.captcha">
              <i slot="prefix" class="iconfont icondengluzhuce_yanzhengma" :class="registerForm.captcha && 'red_color'"></i>
            </el-input>
            <div class="codeFormItem-codeBox"  @click="getImgAgain">
              <img :src="imgSrc" width="100%" height="100%" v-if="imgSrc" />
            </div>
            <div class="codeFormItem-text" @click="getImgAgain">{{$lang("换一张")}}</div>
          </el-form-item> -->
          <div class="agreement">
            <el-checkbox v-model="isAgreement"></el-checkbox>
            <p class="agreement_txt">
              {{$lang("我已阅读并接受")}}<span class="agreement-click" @click="agreementClick">《{{$lang("极兔开放平台注册使用协议")}}》</span>{{$lang("和")}}<span class="agreement-click" @click="privacyClick">《{{$lang("隐私政策")}}》</span>
            </p>
          </div>
          <button class="commonBtn registerBtn" @click.prevent="register" :disabled="!isAgreement">
            {{$t("注 册")}}
          </button>
        </el-form>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-show="isShow1">
    </div>
    <!-- 弹出层-极兔开放平台注册使用协议 -->
    <div class="mask-agreement " v-if="isShow2">
      <h1 class="header">{{$lang("用户协议")}}</h1>
      <articlesOfAgreement_en v-if="$i18n.locale === 'en'" class="content"></articlesOfAgreement_en>
      <articlesOfAgreement v-else class="content"></articlesOfAgreement>
      <div class="footer">
        <el-button type="primary" @click="close(2)">{{$lang("确 定")}}</el-button>
      </div>
    </div>
    <!-- 弹出层-隐私政策 -->
    <div class="mask-privacy " v-if="isShow3">
      <h1 class="header">{{$lang("隐私政策")}}</h1>
      <privacyPolicy v-if="$i18n.locale === 'zh-cn'" class="content"></privacyPolicy>
      <privacyPolicy_ar v-else-if="$i18n.locale === 'ar'" class="content"></privacyPolicy_ar>
      <privacyPolicy_en v-else class="content"></privacyPolicy_en>
      <div class="footer">
        <el-button type="primary" @click="close(3)">{{$lang("确 定")}}</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import * as Api from "@/api";
import { RULES, VALIDATION } from "@/constants/rules";
import { RESPONSE_SUCCESS } from "@/constants";
import { mapActions } from "vuex";
import articlesOfAgreement from "./components/ArticlesOfAgreement";
import privacyPolicy from "./components/PrivacyPolicy";
import { AESUtil } from "@/utils/";
export default {
  name: "Register",
  components: {
    articlesOfAgreement,
    articlesOfAgreement_en:()=> import('./components/ArticlesOfAgreement_en.vue'),
    privacyPolicy,
    privacyPolicy_ar:()=> import('./components/privacyPolicy_ar.vue'),
    privacyPolicy_en:()=> import('./components/privacyPolicy_en.vue'),
  },
  data() {
    return {
      registerForm: {
        account: "",
        password: "",
        phone: "",
        email: "",
        emailCode: "",
        captcha: "", //验证码
        ctoken: "",
        countryCode: 55 // 区号
      },
      countryCodeList: [
        {
          label: "+55",
          value: 55
        },
        {
          label: "+86",
          value: 86
        }
      ],
      rules: {
        account: [RULES.account],
        password: [RULES.password, RULES.passwordNew],
        phone: [RULES.phone, RULES.checkPhone],
        captcha: [RULES.captcha],
        email: [RULES.required, RULES.email],
        emailCode: [RULES.emailCode],
      },
      imgSrc: "",
      name: "",
      isSendCode: false,
      time: 60,
      codeTimer: null,
      isShowPassword: false, //不显示
      phoneStatus: {
        isPass: false, //手机号是否可以发送验证码 需等待验证之后才可发送验证码
        isLoading: false,
        msg: "",
      },
      emailTime: 60,
      isSendEmailCode: false,
      isSendEmailLoading: false,
      emailCodeTimer: null,
      btnIsLoad: true, //注册按钮是否可以点击  防止多次提交
      isAgreement: false, // 是否勾选阅读单选框
      isShow1: false, // 遮罩层
      isShow2: false, // 协议-遮罩层
      isShow3: false, // 隐私协议-遮罩层
      captcha: '',
      captchaType: ''
    };
  },
  created() {
    // this.getImg();
    this.initTencentCaptcha()
  },
  destroyed() {
    clearInterval(this.codeTimer);
    clearInterval(this.emailCodeTimer);
  },
  computed: {
    lang() {
      return this.$store.state.base.lang
    },
    isEmailValid() {
      const email = this.registerForm.email
      if (!email) return false
      return email.length <= 32 && VALIDATION.email.value.test(email)
    }
  },
  methods: {
    ...mapActions(["LOGIN_INIT"]),
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword;
    },
    /**
     * @description 1.获取图形验证码
     */
    async getImg() {
      const res = await Api.getCaptcha();
      const { code, data } = res;
      if (code === RESPONSE_SUCCESS) {
        this.imgSrc = data.img;
        this.registerForm.ctoken = data.ctoken;
      }
    },
    /**
     * @description 2.再次获取图形验证码
     */
    getImgAgain() {
      this.getImg();
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = this.$Captcha.init(
        this.tencentCaptchaCallback,
        {forceLang: this.lang === 'CN' ? 'zh-cn' : 'en'}
      );
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log("腾讯验证码回调：callback", res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr,
        };
        if (this.captchaType === 'register') {
          this.registerApi(customParams)
        } else {
          this.sendCodeApi(customParams);
        }
        this.captchaType = ''
        return res;
      }
      // 验证不成功
      return null;
    },
    /**
     * @description 3.发送邮箱验证码
     */
    sendEmailCode() {
      if (!this.registerForm.email) {
        return this.$message.warning(this.$lang("请输入邮箱"));
      }
      if (this.isSendEmailCode) {
        return;
      }
      this.captcha.show()
    },
    sendCodeApi(customParams) {
      this.isSendEmailLoading = true;
      let httpParams = {
        account: this.registerForm.account,
        email: this.registerForm.email,
        ...customParams
      };
      Api.sendEmail(httpParams).then((res) => {
        this.isSendEmailLoading = false;
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendEmailCode = true;
          clearInterval(this.emailCodeTimer);
          this.emailCodeTimer = setInterval(() => {
            this.emailTime--;
            if (this.emailTime === 0) {
              this.isSendEmailCode = false;
              this.emailTime = 60;
            }
          }, 1000);
          this.$message.success(this.$lang("获取邮箱验证码成功"));
        } else {
          this.$message.error(res.msg);
        }
      }).catch(() => {
        this.isSendEmailLoading = false;
      });
    },
    /**
     * @description 4.注册
     */
    register() {
      if (!this.btnIsLoad) {
        return;
      }
      this.btnIsLoad = false;
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.captchaType = 'register'
          this.captcha.show()
        } else {
          this.btnIsLoad = true;
          console.log("error submit!!");
          return false;
        }
      });
    },
    registerApi(customParams) {
      const { password, account, phone, email, emailCode, captcha, ctoken, countryCode } = this.registerForm;
      // 注册时需要把区号拼接到手机号前面
      Api.register({
        account,
        phone: countryCode + phone,
        email,
        emailCode,
        captcha,
        ctoken,
        password: AESUtil.aesEncrypt(password),
        ...customParams
      })
        .then((res) => {
          this.btnIsLoad = true;
          if (res.code === RESPONSE_SUCCESS) {
            this.$message.success(this.$lang("注册成功"));
            //注册完了直接登录
            this.LOGIN_INIT({ user: res.data, token: res.data.token });
            this.$router.push({ path: "/" });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.btnIsLoad = true;
        });
    },
    /**
     * @description 5.校验账户
     */
    checkAccount() {
      if (!this.registerForm.account) {
        return false;
      }
      let params = {
        account: this.registerForm.account,
      };
      Api.checkUserByPhoneOrAccount(params).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          console.log("账号没有注册");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @description 6.校验手机号
     */
    checkPhone() {
      if (!this.registerForm.phone) {
        return false;
      }
      let params = {
        phone: this.registerForm.phone,
      };
      this.phoneStatus.isLoading = true;
      this.phoneStatus.msg = this.$lang("手机号效验中，请稍后再试...");
      Api.checkUserByPhoneOrAccount(params).then((res) => {
        this.phoneStatus.isLoading = false;
        if (res.code === RESPONSE_SUCCESS) {
          console.log("手机号没有注册");
          this.phoneStatus.msg = null;
          this.phoneStatus.isPass = true;
        } else {
          this.phoneStatus.msg = res.msg;
          this.phoneStatus.isPass = false;
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @description 点击协议
     */
    agreementClick() {
      this.isShow1 = true;
      this.isShow2 = true;
    },
    /**
     * @description 点击隐私政策
     */
    privacyClick() {
      this.isShow1 = true;
      this.isShow3 = true;
    },
    /**
     * @description 点击确认，关闭遮罩层
     */
    close(val) {
      this.isShow1 = false;
      if (val === 2) {
        this.isShow2 = false;
      }
      if (val === 3) {
        this.isShow3 = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  height: 100%;
  background: $theme-color url("../../assets/images/register/background.png")
    no-repeat 80px center;
  background-size: 53%;
  position: relative;
  font-family: PingFang, PingFang-SC;
  .register-box {
    position: absolute;
    top: 50%;
    right: 160px;
    width: 520px;
    // height: 636px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    padding: 50px 100px;
    box-sizing: border-box;
    transform: translateY(-50%);

    .iconBox {
      text-align: center;
      .iconfont {
        font-size: 31px;
        line-height: 31px;
        color: $theme-color;
      }
    }
    .title {
      font-size: 20px;
      text-align: center;
      color: $theme-color;
      line-height: 20px;
      margin-top: 40px;
      font-weight: 600;
      user-select: none;
      &.zh-cn{
        letter-spacing: 40px;
      margin-right: -40px;
      }
    }
    .form {
      margin-top: 30px;
      .iconfont {
        font-size: 20px;
        &.red_color {
          color: $theme-color;
        }
      }
      .registerBtn {
        width: 320px;
        height: 54px;
        margin-top: 10px;
        background: $theme-color;
        color: #fff;
        font-size: 18px;
      }
      .codeFormItem {
        position: relative;
      }
      .codeFormItem-codeBox {
        cursor: pointer;
        position: absolute;
        width: 108px;
        height: 50px;
        background: #dad5d0;
        left: 160px;
        top: 0;
      }
      .codeFormItem-text {
        font-size: 14px;
        color: $theme-color;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }
    .phoneCodeItem {
      position: relative;
      .sendcodeBtn {
        position: absolute;
        width: 60px;
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
        right: 10px;
        top: 9px;
        border: 1px solid #c4c8cc;
      }
    }
    .agreement {
      display: flex;
      font-size: 13px;
      .agreement_txt{
        padding: 0 10px;
      }
      .agreement-click {
        cursor: pointer;
        color: $theme-color;
      }
    }
    .phone::v-deep {
      .el-input-group__prepend {
        width: 30%;
      }
    }
  }
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #000;
    opacity: 0.5;
    z-index: 200;
  }
  .mask-agreement {
    max-width: 1200px;
    width: 100%;
    max-height: 700px;
    background-color: #ffffff;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex: 1;
    flex-direction: column;
    z-index: 300;
    .header {
      width: 100%;
      height: 100px;
      text-align: center;
      color: #ffffff;
      background-color: #333;
      opacity: 0.5;
      padding: 20px 0;
    }
    .content {
      overflow: auto;
    }
    .footer {
      width: 100%;
      text-align: center;
      padding: 20px 0;
      .el-button {
        width: 215px;
        height: 40px;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .mask-privacy {
    max-width: 1200px;
    width: 100%;
    max-height: 700px;
    background-color: #ffffff;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex: 1;
    flex-direction: column;
    z-index: 300;
    .header {
      width: 100%;
      height: 100px;
      text-align: center;
      color: #ffffff;
      background-color: #333;
      opacity: 0.5;
      padding: 20px 0;
    }
    .content {
      overflow: auto;
    }
    .footer {
      width: 100%;
      padding: 20px 0;
      text-align: center;
      .el-button {
        width: 215px;
        height: 40px;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
.register::v-deep {
  .codeFormItem input {
    width: 146px;
  }
  .el-form-item {
    margin-bottom: 30px !important;
  }
  .el-form-item__content {
    height: 50px;
    line-height: 50px;
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .el-input:focus-within .iconfont {
    color: $theme-color;
  }
  .el-input__prefix {
    left: 10px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 40px;
  }
  .el-input__suffix {
    right: 10px;
  }
}
@media only screen and (max-width: 1440px) {
  .register {
    .register-box {
      padding: 30px 100px 50px !important;
    }
    .title {
      margin-top: 20px !important;
    }
    .form {
      margin-top: 20px !important;
    }
  }
}

[dir="rtl"] .register ::v-deep {
  background-position: right 80px center;
  .register-box{
    right: inherit;
    left: 160px;
  }
  .el-input__prefix {
    left: inherit;
    right: 10px;
  }
  .el-input--prefix .el-input__inner {
    // padding-left: 40px;
    padding-right: 40px;
  }
  .el-input--suffix .el-input__inner {
    // padding-right: 40px;
    padding-left: 10px;
  }
  .el-input__suffix {
    right: initial;
    left: 10px;
  }

  .register-box {
    .form {
      .codeFormItem-codeBox {
        left: 50px;
      }
      .codeFormItem-text {
        right: inherit;
        left: 0;
      }
    }
    .phoneCodeItem {
      position: relative;
      .sendcodeBtn {
        right: initial;
        left: 10px;
      }
      }
  }
}
</style>
